<ng-container *transloco="let t; read: 'user'">
<div class="mt-4 shadow-lg shadow-drdpblue-100 rounded-[30px] py-4 px-6 bg-white flex-col justify-between">
  <div class="flex items-center justify-between">
    <!-- Message body is user-generated content. -->
    <p id="message" class="w-5/6">{{ message.message }}</p>
    @if (!isArchived) {
      <button class="self-start" (click)="emitArchiveMessage()">
        <i class="uil uil-times-circle text-red-500 text-lg"></i>
      </button>
    }
  </div>
  <div class="flex items-center pt-4">
    <div id="date">
      <p class=" text-[#757575]">{{ t('dashboard.portfolio.messages.sentByOnDate', { date: (message.createdOn | localDate | localizedDate: 'longDate'), name: senderName }) }}</p>
    </div>
    @if (message.messageRecipients?.length && message.messageRecipients[0].messageStatusId === MessageStatus.New) {
      <div id="newBadge"
        class="bg-drdpblue-300 text-white text-sm rounded-full px-2 py-1 ml-2">
        {{ t('dashboard.portfolio.messages.newBadge') }}
      </div>
    }
  </div>
</div>
</ng-container>
